document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  var searchToggleBtns = document.querySelectorAll('[data-search-toggle]');
  var searchCloseBtn = document.querySelector('[data-search-close]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  var emptyText = searchDrawer ? searchDrawer.getAttribute('data-empty-text') : '';
  var debounceTimer;

  function openSearch() {
    body.classList.add('search-open');
    if (searchInput) {
      searchInput.focus();
    }
  }

  function closeSearch() {
    body.classList.remove('search-open');
  }

  searchToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', closeSearch);
  }

  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
    }
  });

  function formatMoney(amount) {
    return '€' + parseFloat(amount).toFixed(2);
  }

  function renderResults(products) {
    if (products.length === 0) {
      searchResults.innerHTML = '<p class="search-drawer__empty">' + emptyText + '</p>';
      return;
    }

    var html = '';
    products.forEach(function (product) {
      html += '<a href="' + product.url + '" class="search-result">';
      html += '<img src="' + product.image + '" alt="' + product.title + '" class="search-result__image" width="60" height="60">';
      html += '<div>';
      html += '<p class="search-result__title">' + product.title + '</p>';
      html += '<span class="search-result__price">' + formatMoney(product.price_min) + '</span>';
      html += '</div></a>';
    });

    searchResults.innerHTML = html;
  }

  function performSearch(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        renderResults(data.resources.results.products);
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        performSearch(query);
      }, 300);
    });
  }
});